import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ThemeToggle } from '@/components/theme-toggle';
import { Factory, Package, Settings, TrendingUp, Search, Plus, LogOut } from 'lucide-react';
import { signOut, useSession } from '@/lib/authClient';
import type { AppStep } from '@/types/app';

interface AppHeaderProps {
  currentStep: AppStep;
  onNavigate: (step: AppStep) => void;
}

export function AppHeader({ currentStep, onNavigate }: AppHeaderProps) {
  const { data: session } = useSession();

  const handleSignOut = async () => {
    await signOut();
    window.location.href = '/login';
  };

  return (
    <header className="border-b bg-card">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <Factory className="h-6 w-6" />
              <span className="font-semibold text-lg">EtsyFlow Studio</span>
            </div>
            <nav className="hidden md:flex items-center gap-1 ml-8">
              <Button
                variant={currentStep === 'dashboard' ? 'secondary' : 'ghost'}
                size="sm"
                onClick={() => onNavigate('dashboard')}
              >
                Dashboard
              </Button>
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={() => onNavigate('upload')}
              >
                <Plus className="h-4 w-4 mr-1" />
                Create
              </Button>
              <Button
                variant={currentStep === 'products' ? 'secondary' : 'ghost'}
                size="sm"
                onClick={() => onNavigate('products')}
              >
                <Package className="h-4 w-4 mr-1" />
                Products
              </Button>
              <Button variant="ghost" size="sm">
                <TrendingUp className="h-4 w-4 mr-1" />
                Analytics
              </Button>
              <Button
                variant={currentStep === 'settings' ? 'secondary' : 'ghost'}
                size="sm"
                onClick={() => onNavigate('settings')}
              >
                <Settings className="h-4 w-4 mr-1" />
                Settings
              </Button>
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <div className="relative hidden md:block">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
              <Input
                placeholder="Search..."
                className="pl-9 w-64 h-9"
              />
            </div>
            <ThemeToggle />
            {session && (
              <Button variant="ghost" size="sm" onClick={handleSignOut}>
                <LogOut className="h-4 w-4 mr-1" />
                Sign out
              </Button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

